import { Row } from 'react-bootstrap'
import RecordingCard from './RecordingCard'
import { useContext } from 'react'
import { PlayerContext } from '../../pages/Home'

const RecordingList = ({ recordingList }) => {
  const { playRecordings } = useContext(PlayerContext)

  if (!recordingList) return ''

  const playFn = (index) => {
    playRecordings(recordingList, index)
  }

  return (
    <Row className='g-4' xs={2} sm={2} md={3} lg={4} xl={4} xxl={5}>
      {recordingList.map((recording, i) => (
        <RecordingCard
          recording={recording}
          key={recording.name}
          index={i}
          playFn={playFn}
        />
      ))}
    </Row>
  )
}
export default RecordingList
